import React from 'react';
import { Box, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const TourCardsSectionSkeleton = () => (
  <Box sx={{ my: 3 }}>
    <Grid container rowSpacing={3} sx={{ my: 3 }}>
      <Grid item lg={3} md={6} sm={12}>
        <Skeleton variant="text" width="100%" height={50} />
      </Grid>
      <Grid item lg={7} md={1} sm={12} />
      <Grid lg={2} md={5} sm={12}>
        <Skeleton variant="text" width="100%" height={70} />
      </Grid>
    </Grid>
    <Grid container spacing={3}>
      {[...Array(5).keys()].map((item) => (
        <Grid item key={item} xxl={2.4} xl={3} lg={3} md={6} sm={12} xs={12}>
          <Skeleton variant="rounded" width="100%" height={200} />
          <Skeleton variant="text" width="100px" height={20} />
          <Skeleton variant="text" width="80%" height={40} />
          <Skeleton variant="text" width="60%" height={20} />
          <Skeleton variant="text" width="40%" height={20} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export { TourCardsSectionSkeleton };
